<template>
    <div class="business-info-entry">
      <z-fix-top
        keep-position
        class="fixtop"
      >
        <z-nav-bar
            class="navbar"
            left-arrow
            title="经营信息"
            style="background: #F8F8F8"
            @click-left="closePage"
        >
        </z-nav-bar>
      </z-fix-top>
      <header>您未声明或亮照</header>
      <div class="desc">{{msg}}</div>
      <section class="cell">
        <z-cell-group inset>
          <z-cell title="登记亮照" :is-link="false" @click="toSubmit('1')" value="去上传" label="已有营业执照，我要上传" value-class="toSubmit"/>
        </z-cell-group>
        <z-cell-group inset>
          <z-cell title="免登声明" :is-link="false"  @click="toSubmit('2')" value="去声明" label="属依法无需办照情形，我要声明" value-class="toSubmit" label-class="labelInformation"/>
        </z-cell-group>
        <z-cell-group inset>
          <z-cell title="经营场所证明" :is-link="false"  @click="toSubmit('3')" value="去申请" label="开具经营场所证明，用于证照办理" value-class="toSubmit" label-class="labelInformation"/>
        </z-cell-group>
      </section>
    </div>
</template>
<script>
import native from '@zz-common/native-adapter';
import { FixTop, NavBar, Cell, CellGroup } from '@zz-common/zz-ui'

export default {
  name: 'StateComp',
  data() {
    return {
      msg: '根据国家法律法规规定，网络交易经营者应当办理营业执照并“亮照”公示，或进行"免登声明"'
    };
  },
  computed: {
  },
  methods: {
    closePage() {
      native.close();
    },
    toSubmit(type) {
      if (type == '1') {
        native.skipToUrl({
          targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/qualityauth/license?sourceCode=biz_selfmain',
          needClose: '1'
        })
      }
      if (type == '2') {
        native.skipToUrl({
          targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/bussinessInfo/personDeclaration?issubmit=0&from=biz_selfmain',
          needClose: '1'
        })
      }
      if (type == '3') {
        native.skipToUrl({
          targetUrl: 'https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/bussinessInfo/placeOfBusiness?from=license_location',
          needClose: '1'
        })
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-cell': Cell,
    'z-cell-group': CellGroup
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
